// extracted by mini-css-extract-plugin
export default {"error":"PrescriptionModal__error--aBzMT","btnActions":"PrescriptionModal__btnActions--+nOJx","prescriptionModal":"PrescriptionModal__prescriptionModal--aAxy3"};